import {Injectable, Injector} from "@angular/core";
import {EntityModel} from "@fedeltapointofsale/data-client";
import {LocationData} from "./location.data";

/**
 * this is used for add, edit and delete actions for Location Data
 */
@Injectable()
export class LocationEntityModel extends EntityModel<LocationData> {

    constructor(injector: Injector) {
        super(injector, LocationData);
    }
}
